function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import Sortable from 'sortablejs';
import { useTranslation } from 'react-i18next';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { Container, IconWrapper, AddStep } from './FunnelSteps.styles';
import { mutateArray } from '../../utils';
import FunnelStep from '../FunnelStep';
import { addFunnelStep, setFunnelSteps, removeFunnelStep, getFunnelSteps, changeFunnelStepsOrder, cloneFunnelStep } from '../../modules/query';
import { getChartSettings, updateChartSettings } from '../../modules/chartSettings';
import { AppContext } from '../../contexts';
import { DRAG_ANIMATION_TIME } from './constants';
import { getDefaultTimezone } from '../../modules/timezone';

var FunnelSteps = function FunnelSteps() {
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var steps = useSelector(getFunnelSteps);
  var defaultTimezone = useSelector(getDefaultTimezone);
  var stepLabels = useSelector(function (state) {
    var _getChartSettings = getChartSettings(state),
        funnelStepsLabels = _getChartSettings.stepLabels;

    if (funnelStepsLabels) return funnelStepsLabels;
    return [];
  });

  var _useContext = useContext(AppContext),
      onUpdateChartSettings = _useContext.onUpdateChartSettings;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      stepVisible = _useState2[0],
      setStepVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDragged = _useState4[0],
      setDragMode = _useState4[1];

  var sortableRef = useRef(null);
  var stepsRef = useRef(null);
  stepsRef.current = steps;
  var stepsLabelsRef = useRef(null);
  stepsLabelsRef.current = stepLabels;
  useEffect(function () {
    new Sortable(sortableRef.current, {
      animation: DRAG_ANIMATION_TIME,
      filter: '.add-step',
      handle: '.dragBar',
      onStart: function onStart() {
        return setDragMode(true);
      },
      onMove: function onMove(evt) {
        return !evt.related.className.includes('add-step');
      },
      onEnd: function onEnd(evt) {
        var updatedSteps = mutateArray(stepsRef.current, evt.oldIndex, evt.newIndex);
        dispatch(changeFunnelStepsOrder(updatedSteps));
        setDragMode(false);

        if (stepsLabelsRef === null || stepsLabelsRef === void 0 ? void 0 : stepsLabelsRef.current.length) {
          var updatedStepLabels = mutateArray(stepsLabelsRef.current, evt.oldIndex, evt.newIndex);
          dispatch(updateChartSettings({
            stepLabels: updatedStepLabels
          }));
          onUpdateChartSettings({
            stepLabels: updatedStepLabels
          });
        }
      }
    });
    return function () {
      dispatch(setFunnelSteps([]));
    };
  }, []);
  var handleStepLabelChange = useCallback(function (label, idx) {
    var updatedStepLabels = _toConsumableArray(stepLabels);

    updatedStepLabels[idx] = label;
    dispatch(updateChartSettings({
      stepLabels: updatedStepLabels
    }));
    onUpdateChartSettings({
      stepLabels: updatedStepLabels
    });
  }, [stepLabels]);
  return React.createElement(Container, {
    ref: sortableRef
  }, !!steps.length && steps.map(function (_ref, idx) {
    var id = _ref.id,
        eventCollection = _ref.eventCollection,
        timeframe = _ref.timeframe,
        timezone = _ref.timezone,
        inverted = _ref.inverted,
        optional = _ref.optional,
        actorProperty = _ref.actorProperty,
        filters = _ref.filters;
    return React.createElement(FunnelStep, {
      key: id,
      id: id,
      index: idx,
      timeframe: timeframe,
      timezone: timezone,
      actorProperty: actorProperty,
      eventCollection: eventCollection,
      inverted: inverted,
      optional: optional,
      filters: filters,
      onRemove: function onRemove() {
        dispatch(removeFunnelStep(id));

        if (stepsLabelsRef === null || stepsLabelsRef === void 0 ? void 0 : stepsLabelsRef.current.length) {
          var updatedStepLabels = _toConsumableArray(stepsLabelsRef.current);

          updatedStepLabels.splice(idx, 1);
          dispatch(updateChartSettings({
            stepLabels: updatedStepLabels
          }));
          onUpdateChartSettings({
            stepLabels: updatedStepLabels
          });
        }
      },
      onLabelChange: function onLabelChange(label, idx) {
        return handleStepLabelChange(label, idx);
      },
      detailsVisible: stepVisible === id,
      isFirstStep: idx === 0,
      isDragged: isDragged,
      stepLabel: stepLabels[idx] || undefined,
      setDetailsVisible: function setDetailsVisible(id) {
        return setStepVisible(id);
      },
      onClone: function onClone(id) {
        var stepId = uuid();
        dispatch(cloneFunnelStep(id, stepId));
        setStepVisible(stepId);

        if (stepsLabelsRef === null || stepsLabelsRef === void 0 ? void 0 : stepsLabelsRef.current.length) {
          var updatedStepLabels = [].concat(_toConsumableArray(stepsLabelsRef.current), [null]);
          dispatch(updateChartSettings({
            stepLabels: updatedStepLabels
          }));
          onUpdateChartSettings({
            stepLabels: updatedStepLabels
          });
        }
      }
    });
  }), React.createElement(AddStep, {
    className: "add-step",
    "data-testid": "add-step-button",
    onClick: function onClick() {
      var stepId = uuid();
      dispatch(addFunnelStep(stepId, defaultTimezone));
      setStepVisible(stepId);
    }
  }, React.createElement(IconWrapper, null, React.createElement(Icon, {
    type: "plus",
    width: 13,
    height: 13,
    fill: colors.green[500]
  })), t('query_creator_funnel_steps.add_step')));
};

export default FunnelSteps;